import { useQuery } from "@tanstack/react-query";
import { getLeaveDays } from "../../leaveManagement/api";
import { LeaveType } from "../../leaveManagement/type";

export type LeaveDate = {
  id: string;
  type: LeaveType;
  date: string;
  employee_code: string;
  employee_id: number;
  employee_name: string;
  leave_id: string;
  created_at: string;
  updated_at: string;
};

export const leaveDateKeys = {
  all: ["emp-leave-dates"] as const,
  list: (id: number) => 
    [...leaveDateKeys.all, 'list', id] as const
};

export const useLeaveDays = ({ id }: { id: number }) => {
  return useQuery<LeaveDate[]>({
    queryKey: leaveDateKeys.list(id),
    queryFn: () => getLeaveDays(id),
    enabled: !!id,
    staleTime: 60 * 60 * 1000 * 5,
    gcTime: 60 * 60 * 1000 * 5,
  });
};
